// mrp_scripts.js
// Última atualização: 29 jul 2025 – dots = itens‑visíveis + rolagens

/* --------------------------------------------------
 *  CARROSSEL DE DIFERENCIAIS
 * --------------------------------------------------*/
(function initCarrosselDiferenciais() {
  const container = document.querySelector(".carrossel-diferenciais");
  if (!container) return;

  container.querySelectorAll(".carrossel-diferenciais-item").forEach((item) => {
    item.addEventListener("click", () => {
      container.querySelectorAll(".carrossel-diferenciais-item").forEach((i) => {
        if (i !== item) i.classList.remove("active");
      });
      item.classList.toggle("active");
    });
  });
})();

/* --------------------------------------------------
 *  ACCORDIONS
 * --------------------------------------------------*/
function initAccordions(root = document) {
  root.querySelectorAll("[data-accordion]").forEach((accordion) => {
    accordion.querySelectorAll(".accordion-header").forEach((header) => {
      header.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
      });
    });
  });
}

/* --------------------------------------------------
 *  CARROSSEL GENÉRICO (produtos, influencers, etc)
 * --------------------------------------------------*/
function initGenericCarousel(wrapper) {
  if (!wrapper || wrapper.dataset.carouselInitialized) return;
  wrapper.dataset.carouselInitialized = true;

  const track = wrapper.querySelector(
    ".carrossel-influencers-scroll, .featured-collection, .galeria-collection"
  );
  if (!track) return;

  const prev = wrapper.querySelector(".carousel-btn.prev");
  const next = wrapper.querySelector(".carousel-btn.next");
  const dotsWrap = wrapper.querySelector(".carousel-dots");

  track.style.scrollbarWidth = "none";
  track.style.msOverflowStyle = "none";
  track.classList.add("no-scrollbar");

  const getGap = () => parseFloat(getComputedStyle(track).gap || 16);
  const realItems = () =>
    [...track.children].filter((el) =>
      el.matches(".item, .galeria-item, .carrossel-influencers-item")
    );
  const itemW = () => {
    const el = realItems()[0];
    return el ? el.getBoundingClientRect().width + getGap() : 0;
  };
  const itemsPerView = () => Math.max(1, Math.round(track.clientWidth / itemW()));
  const totalDots = () =>
    Math.max(1, realItems().length - itemsPerView() + 1);
  const clampIdx = (idx) =>
    Math.max(0, Math.min(idx, realItems().length - 1));
  const scrollToIdx = (idx) =>
    track.scrollTo({ left: itemW() * clampIdx(idx), behavior: "smooth" });

  prev?.addEventListener("click", () =>
    scrollToIdx(clampIdx(Math.round(track.scrollLeft / itemW()) - 1))
  );
  next?.addEventListener("click", () =>
    scrollToIdx(clampIdx(Math.round(track.scrollLeft / itemW()) + 1))
  );

  const renderDots = () => {
    if (!dotsWrap) return;
    const n = totalDots();
    dotsWrap.innerHTML = "";
    if (n <= 1) return;
    for (let i = 0; i < n; i++) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "carousel-dot";
      dot.addEventListener("click", () => scrollToIdx(i));
      dotsWrap.appendChild(dot);
    }
    updateActiveDot();
  };

  const updateActiveDot = () => {
    if (!dotsWrap) return;
    const idx = Math.min(
      Math.round(track.scrollLeft / itemW()),
      totalDots() - 1
    );
    dotsWrap
      .querySelectorAll(".carousel-dot")
      .forEach((d, i) => d.classList.toggle("active", i === idx));
  };

  track.addEventListener("scroll", () => requestAnimationFrame(updateActiveDot));
  addEventListener("resize", () => {
    renderDots();
    updateActiveDot();
  });

  renderDots();
}

/* --------------------------------------------------
 *  INICIALIZA TODOS OS CARROSSEIS
 * --------------------------------------------------*/
function initAllCarousels(root = document) {
  root
    .querySelectorAll(".carousel-wrapper, .carrossel-influencers")
    .forEach(initGenericCarousel);
}

/* --------------------------------------------------
 *  BOOTSTRAP GERAL (DOM Ready & Shopify Editor)
 * --------------------------------------------------*/
function bootstrap(root = document) {
  initAccordions?.(root);
  initAllCarousels?.(root);
  applyGradientToTitles?.();
}

document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", () => bootstrap(document))
  : bootstrap(document);

document.addEventListener("shopify:section:load", (e) => bootstrap(e.target));


/* --------------------------------------------------
 *  CARREGAMENTO IMAGENS HOME
 * --------------------------------------------------*/
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("img").forEach((img) => {
    if (img.complete) {
      img.classList.add("loaded");
    } else {
      img.addEventListener("load", () => {
        img.classList.add("loaded");
      });
    }
  });
});
